<template>
  <div class="the-others">
    <div
      class="the-others__container"
      data-in-out
      data-in-out-animation="slide"
      data-medusa
      data-medusa-animation="the-others"
    >
      <div class="the-others__title" v-html="`${$t('others')}.`"></div>
      <div class="the-others__text">
        <!-- <span>
          {{ $t('family') }}
        </span> -->

        <!-- <router-link
          class="the-others__all"
          data-apollo-hover
          data-apollo-hover-animation="scale" :to="`/${$store.state.lang}/collection`"
        >
          <div class="the-others__all-label">
            <span>{{ $t('viewAll') }}</span>
          </div>
          <div class="the-others__all-icon">
            <ArrowBall />
          </div>
        </router-link> -->
      </div>
    </div>

    <div
      class="the-others__showcase"
      data-in-out
      data-in-out-animation="slide"
    >
      <div class="the-others__showcase-row" data-medusa data-medusa-animation="showcase">
        <div class="the-others__showcase-bottle-wrapper">
          <ShowcaseBottle
            :color="'black'"
            :name="'<div class=\'stagger\'>Cuvée</div><div class=\'stagger\'>1821</div>'"
            :to="'/collection/cuvee-1821'"
            :image="'/static/bottles/cuvee-1821/preview.jpg'"
            :imageHover="'/static/bottles/cuvee-1821/preview_hover.jpg'"
          />
        </div>
        <div class="the-others__showcase-bottle-wrapper">
          <ShowcaseBottle
            :color="'grey'"
            :name="'<div class=\'stagger\'>Rosé</div><div class=\'stagger\'>1821</div>'"
            :to="'/collection/rose-1821'"
            :image="'/static/bottles/rose-1821/preview.jpg'"
            :imageHover="'/static/bottles/rose-1821/preview_hover.jpg'"
          />
        </div>
        <div class="the-others__showcase-bottle-wrapper">
          <ShowcaseBottle
            :color="'grey'"
            :name="'<div class=\'stagger\'>Special Cuvée</div><div class=\'stagger\'>Millesimato</div>'"
            :to="'/collection/special-cuvee-millesimato'"
            :image="'/static/bottles/special-cuvee-millesimato/preview.jpg'"
            :imageHover="'/static/bottles/special-cuvee-millesimato/preview_hover.jpg'"
          />
        </div>
      </div>
      <div class="the-others__showcase-row" data-medusa data-medusa-animation="showcase">
        <div class="the-others__showcase-bottle-wrapper">
          <ShowcaseBottle
            :color="'white'"
            :name="'<div class=\'stagger\'>Prestige</div><div class=\'stagger\'>1821</div>'"
            :to="'/collection/prestige-1821'"
            :image="'/static/bottles/prestige-1821/preview.jpg'"
            :imageHover="'/static/bottles/prestige-1821/preview_hover.jpg'"
          />
        </div>
        <div class="the-others__showcase-bottle-wrapper">
          <ShowcaseBottle
            :color="'black'"
            :name="'<div class=\'stagger\'>Collezione Leone</div><div class=\'stagger\'>Prosecco</div>'"
            :to="'/collection/collezione-leone-prosecco-doc'"
            :image="`/static/bottles/collezione-leone-prosecco-doc/preview-${$store.state.lang}.jpg`"
            :imageHover="`/static/bottles/collezione-leone-prosecco-doc/preview_hover-${$store.state.lang}.jpg`"
          />
        </div>
        <div class="the-others__showcase-bottle-wrapper">
          <ShowcaseBottle
            :color="'grey'"
            :name="'<div class=\'stagger\'>Collezione Leone</div><div class=\'stagger\'>Prosecco Rosé</div>'"
            :to="'/collection/collezione-leone-prosecco-doc-rose'"
            :image="'/static/bottles/collezione-leone-prosecco-doc-rose/preview.jpg'"
            :imageHover="'/static/bottles/collezione-leone-prosecco-doc-rose/preview_hover.jpg'"
          />
        </div>
      </div>
      <div class="the-others__showcase-row" data-medusa data-medusa-animation="showcase">
        <div class="the-others__showcase-bottle-wrapper">
          <!-- <ShowcaseBottle
            :color="'grey'"
            :name="'<div class=\'stagger\'>Special Cuvée</div><div class=\'stagger\'>Millesimato</div>'"
            :to="'/collection/special-cuvee-millesimato'"
            :image="'/static/bottles/special-cuvee-millesimato/preview.jpg'"
            :imageHover="'/static/bottles/special-cuvee-millesimato/preview_hover.jpg'"
          /> -->
        </div>
        <div class="the-others__showcase-bottle-wrapper">
          <!-- <ShowcaseBottle
            :color="'white'"
            :name="'<div class=\'stagger\'>Spumante</div><div class=\'stagger\'>Brut</div>'"
            :to="'/collection/spumante-brut'"
            :image="'/static/bottles/spumante-brut/preview.jpg'"
            :imageHover="'/static/bottles/spumante-brut/preview_hover.jpg'"
          /> -->
        </div>
        <div class="the-others__showcase-bottle-wrapper">
          <!-- <ShowcaseBottle
            :color="'black'"
            :name="'Special Cuvée Millesimato'"
            :to="'/collection/special-cuvee-millesimato'"
            :image="'/static/bottles/special-cuvee/preview.jpg'"
            :imageHover="'/static/bottles/special-cuvee/preview.jpg'"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShowcaseBottle from '@/components/contents/ShowcaseBottle.vue';
// import ArrowBall from '@/components/ArrowBall.vue';

export default {
  name: 'TheOthers',

  components: {
    ShowcaseBottle,
    // ArrowBall,
  },
};
</script>

<style lang="scss" scoped>
.the-others {
  width: calc((100vw / 32) * 21);
  margin-top: calc((100vh / 18) * 5);

  @include mq($until: ipadL) {
    width: calc((100vw / 32) * 24);
    margin-top: calc((100vh / 18) * 2);
  }

  &__container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    color: $color-white;

    @include mq($until: ipadL) {
      flex-direction: column;
    }
  }

  &__title {
    width: 100%;
    // flex-basis: calc(50% - (100vw / 64) * 1);
    font-size: rem(150px);
    font-size: calc(150px * var(--rw));
    line-height: rem(170px);
    line-height: calc(170px * var(--rw));

    @include mq($until: ipadL) {
      font-size: rem(60px);
      font-size: calc(60px * var(--rw));
      line-height: rem(70px);
      line-height: calc(70px * var(--rw));
      margin-bottom: calc((100vh / 18) * 1);
    }
  }

  &__text {
    position: relative;
    top: calc(10px + (170px * var(--rw)));
    // flex-basis: calc(50% - (100vw / 32) * 1);
    width: 0;
    font-size: rem(22px);
    font-size: $font-size-text;
    font-weight: 300;
    line-height: 1.8em;

    @include mq($until: ipadL) {
      top: 0px;
    }

    .teal {
      color: $color-primary;
    }
  }

  &__all {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: calc((100vh / 18) * 1);
    cursor: pointer;

    &-icon {
      width: calc(70px * var(--rw));
      height: calc(70px * var(--rw));

      &::v-deep svg circle {
        transform-origin: 50% 50%;
      }
    }

    &:hover ::v-deep svg circle {
      transform: scale(1);

      &.fill {
        stroke-dashoffset: 0;
        transition: transform .3s $inOutCubic,
                    stroke-dashoffset .3s $inOutCubic .2s;
      }
    }

    &:hover ::v-deep .arrow {
      transition: opacity .3s $inOutCubic .2s;
      opacity: 1;

      .arrow-animation {
        animation-name: arrow-loop;
        animation-duration: .8s;
        animation-delay: .3s;
        animation-iteration-count: 1;
        animation-timing-function: $inOutCubic;
      }
    }

    &-arrow {
      width: calc(20px * var(--rw));
      height: calc(20px * var(--rw));
      background-image: url('/static/vector/arrow.svg');
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    &-label {
      margin-right: 50px;
      font-size: rem(35px);
      font-size: calc(35px * var(--rw));
    }
  }

  &__showcase {
    margin-top: calc((100vh / 18) * 5);

    @include mq($until: ipadP) {
      margin-top: 80px;
    }

    &-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      @include mq($until: ipadL) {
        flex-wrap: wrap;
      }
    }
  }

  &__showcase-bottle-wrapper {
    width: calc(242px * var(--rw));

    @include mq($until: ipadL) {
      width: 100%;
    }
  }
}
</style>
